<template>
  <div>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title class="mx-3">
          {{ material.material_name }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="templates"
          :loading="loading"
          multi-sort
          class="elevation-0 px-6"
          v-resize="resizeHeader"
          :footer-props="footerProps"
        >
          <template v-slot:item.price="{ item }">
            <span>
              {{ $t("Global.money") }} {{ item.supply_price | formatMoney }}
            </span>
          </template>

          <template v-slot:item.split_price="{ item }">
            <v-btn
              v-if="item.price_type == 0"
              small
              text
              color="info"
              @click="splitPriceItem = item"
            >
              {{ $t("Opt.details") }}
            </v-btn>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            class="elevation-1"
            @click="dialog = false"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SplitPrice
      v-model="splitPriceItem"
      :price="splitPriceItem ? Number(splitPriceItem.supply_price) : 0"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SplitPrice from "./SplitPrice";
import MaterialTemplates from "@/api/material_templates";

export default {
  name: "TemplatesSelectsDialog",

  props: {
    value: Boolean,
    material: Object,
  },

  components: {
    SplitPrice,
  },

  computed: {
    headers() {
      var headers = [
        {
          text: i18n.t("Material.templates.name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "template.template_name",
          width: 200,
        },

        {
          text: i18n.t("Material.templates.price"),
          align: "center",
          sortable: false,
          filterable: true,
          value: "price",
        },
      ];
      if (
        this.settings &&
        this.settings.sub_account_enable &&
        this.settings.sub_account_enable != 2
      ) {
        headers.push({
          text: i18n.t("Material.templates.splitPrice"),
          align: "end",
          sortable: false,
          filterable: true,
          value: "split_price",
        });
      }

      return headers;
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    templates: [],
    itemsPerPageOptions: 10,
    templateKeyword: "",
    chooseFlgs: [0, 1],
    splitPriceItem: null,
    mode: "",
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    getTemplates() {
      MaterialTemplates.fetchByMaterial(this.material.id, { readonly: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.templates = response.data.material_template_details.filter(
              (detail) => detail.status == 1
            );
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          this.getTemplates();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>